module.exports = __webpack_public_path__ + "static/media/intro-photowall-12.c9911a3c.jpg";